import { MapPin, Layers, Calendar, Tag } from 'lucide-react';
import { defineSchema } from '@shared/search';

export const analysisSchema = defineSchema({
  id: 'analyses',
  title: 'filter.schema.analyses.title',
  subtitle: 'filter.schema.analyses.subtitle',
  defaultField: 'name',
  fields: {
    name: {
      key: 'name',
      label: 'filter.field.nameTrack',
      type: 'text',
      icon: Tag,
      placeholder: 'filter.placeholder.nameTrack',
      description: 'filter.desc.nameTrack',
      example: 'name:Sarno',
    },
    track: {
      key: 'track',
      label: 'filter.field.track',
      type: 'text',
      icon: MapPin,
      placeholder: 'filter.placeholder.track',
      description: 'filter.desc.track',
      example: 'track:Wohlen',
    },
    type: {
      key: 'type',
      label: 'filter.field.toolType',
      type: 'text',
      icon: Layers,
      placeholder: 'filter.placeholder.toolType',
      description: 'filter.desc.toolType',
      example: 'type:sector',
      presets: [
        { label: 'analysis.sector', value: 'sector', operator: '=' },
        { label: 'analysis.corner', value: 'corner', operator: '=' },
        { label: 'analysis.braking', value: 'braking', operator: '=' },
        { label: 'analysis.lapdiff', value: 'lapdiff', operator: '=' },
        { label: 'analysis.aggregation', value: 'aggregation', operator: '=' },
        { label: 'analysis.aggregationdiff', value: 'aggregationdiff', operator: '=' },
      ],
    },
    from: {
      key: 'from',
      label: 'filter.field.date',
      type: 'dateRange',
      icon: Calendar,
      description: 'filter.desc.date',
      example: 'from:-30d',
      datePresets: [
        { label: 'filter.preset.today', value: 'today' },
        { label: 'filter.preset.last7d', value: '-7d' },
        { label: 'filter.preset.last30d', value: '-30d' },
        { label: 'filter.preset.last90d', value: '-90d' },
        { label: 'filter.preset.last1y', value: '-1y' },
      ],
    },
  },
  examples: [
    { q: 'Sarno type:sector', desc: 'filter.example.sarnoSector' },
    { q: 'type:lapdiff from:-30d', desc: 'filter.example.lapdiff30d' },
    { q: '(Wohlen OR Mirecourt) type:corner', desc: 'filter.example.wohlenCorner' },
  ],
});

